module.exports = __webpack_public_path__ + "img/camera-icon.fdc25a30.png";